import { render } from "./CellPassportSections.vue?vue&type=template&id=e7071f1c"
import script from "./CellPassportSections.vue?vue&type=script&lang=js"
export * from "./CellPassportSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/CellPassportSections.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7071f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7071f1c', __exports__)) {
    api.reload('e7071f1c', __exports__)
  }
  
  module.hot.accept("./CellPassportSections.vue?vue&type=template&id=e7071f1c", () => {
    api.rerender('e7071f1c', render)
  })

}


export default __exports__